import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Platform16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.62213 0.352166C7.85565 0.215945 8.14442 0.215945 8.37794 0.352166L14.3779 3.85217C14.865 4.13629 14.865 4.86371 14.3779 5.14783L12.4885 6.25L14.3779 7.35217C14.865 7.63629 14.865 8.36372 14.3779 8.64784L12.4885 9.75001L14.3779 10.8522C14.865 11.1363 14.865 11.8637 14.3779 12.1478L8.37794 15.6478C8.14442 15.7841 7.85565 15.7841 7.62213 15.6478L1.62213 12.1478C1.13507 11.8637 1.13507 11.1363 1.62213 10.8522L3.51156 9.75001L1.62213 8.64784C1.13507 8.36372 1.13507 7.63629 1.62213 7.35217L3.51157 6.25L1.62213 5.14783C1.13507 4.86371 1.13507 4.13629 1.62213 3.85217L7.62213 0.352166ZM5.00004 7.11828L3.48851 8.00001L8.00004 10.6317L12.5116 8.00001L11 7.11828L8.37794 8.64783C8.14442 8.78406 7.85565 8.78406 7.62213 8.64783L5.00004 7.11828ZM5.00004 10.6183L3.48851 11.5L8.00004 14.1317L12.5116 11.5L11 10.6183L8.37794 12.1478C8.14442 12.2841 7.85565 12.2841 7.62213 12.1478L5.00004 10.6183ZM3.48851 4.5L8.00004 7.13172L12.5116 4.5L8.00004 1.86828L3.48851 4.5Z'
      fill='currentColor'
    />
  </Svg>
);

Platform16.displayName = 'Platform16';
export default Platform16;
